import { GtmhubController } from "@gtmhub/core";
import { IComponentOptions, IScope } from "angular";
import { GifSize, GifType, TenorGifService } from "@gtmhub/shared/services/tenor-gif.service";
import { IGif } from "@gtmhub/comments";
import { IIndicator } from "@gtmhub/error-handling";
import { FeatureToggleService } from "@gtmhub/featureToggle";
import { FeatureFlag } from "@gtmhub/featureToggle/models";

export class GifViewCtrl extends GtmhubController {
  indicators: {
    loading?: IIndicator;
  };

  gif: IGif;
  gifSize: GifSize;
  gifURL: string;
  showGif: boolean;
  isModuleGifsEnabled: boolean;

  static $inject = ["$scope", "TenorGifService", "FeatureToggleService"];

  constructor(private $scope: IScope, private gifService: TenorGifService, private featureToggleService: FeatureToggleService) {
    super();

    const unsubscribeFromGifIdWatcher = this.$scope.$watch("$ctrl.gif.id", (newValue, oldValue) => {
      if (!newValue) {
        this.clearGif();
      } else if (newValue !== oldValue) {
        this.applayChangesBesedOnFeautureToggle();
      }
    });

    this.onDestroy(unsubscribeFromGifIdWatcher);
  }

  $onInit(): void {
    this.showGif = false;

    if (!this.gif) {
      this.gif = {
        id: "",
        searchQuery: "",
      };
    }

    this.featureToggleService.isFeatureAvailable(FeatureFlag.ModuleGifs).then((response) => {
      this.isModuleGifsEnabled = response;
      this.applayChangesBesedOnFeautureToggle();
    });
  }

  resetIndicator(indicator: keyof GifViewCtrl["indicators"]): void {
    delete this.indicators[indicator];
  }

  clearGif(): void {
    this.gifURL = "";
    this.gif = {
      id: "",
      searchQuery: "",
    };
    this.showGif = false;
  }

  private applayChangesBesedOnFeautureToggle(): void {
    if (!this.gif.id) {
      return;
    }

    if (this.isModuleGifsEnabled) {
      this.indicators = {
        loading: { progress: true },
      };
      const gifType: GifType = "gifs";

      this.gifService.getGifData({ gifType, gifSize: this.gifSize, gifId: this.gif.id }).then((response) => {
        this.gifURL = response[0].media?.url;
        this.showGif = true;
        delete this.indicators.loading;
      });
    }
  }
}

export const GifViewComponent: IComponentOptions = {
  bindings: {
    gifSize: "<",
    gif: "=",
    showClearBtn: "<",
  },
  controller: GifViewCtrl,
  templateUrl: require("./gif-view.jade"),
};
